/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 2297
// module chunks = 0